module.exports = __webpack_public_path__ + "components/weather-icon/static/nightlightsnow-4a39c62e7e48c07bd5e22afb70d20bd0.webp";